import React, { useState } from 'react';
import { Button, message, Popconfirm } from 'antd';
import css from './BookCard.module.css';
import { usePDFStore } from '../../../Pages/Site/Idb';
import { useSavingLoader } from '../../../Components/SavingLoader/SavingLoader';
import { DeleteOutlined, DownloadOutlined, InfoCircleOutlined } from '@ant-design/icons';
import bookempty from './../../../assets/bookempty.png';
import { Link } from 'react-router-dom';

function BookCard({ book }) {
    const { handleDownloadPDF, loadstatus, deletePDFFromIndexedDB, getPDFByIdFromIndexedDB } = usePDFStore();
    const loaderStore = useSavingLoader();
    const [isDownloaded, setIsDownloaded] = useState(false);

    // Kitob yuklanganligini tekshirish
    React.useEffect(() => {
        checkIfDownloaded();
    }, [book.id]);

    const checkIfDownloaded = async () => {
        try {
            const pdf = await getPDFByIdFromIndexedDB(book.id);
            setIsDownloaded(!!pdf);
        } catch (error) {
            setIsDownloaded(false);
        }
    };

    const handleDownload = async () => {
        if (!navigator.onLine) {
            message.error("Internet aloqasi yo'q. Iltimos, internetga ulanishni tekshiring");
            return;
        }

        try {
            loaderStore.getState().showLoader("Kitob yuklanmoqda...", 0);
            
            const onProgress = (progress) => {
                loaderStore.getState().updateProgress(progress);
                if (progress === 100) {
                    loaderStore.getState().showLoader("Kitob saqlanmoqda...", 100);
                }
            };

            await handleDownloadPDF(book.id, book.name, book.url, book.autor, onProgress);
            setIsDownloaded(true);
        } catch (error) {
            console.error("Kitobni yuklashda xatolik:", error);
        } finally {
            loaderStore.getState().hideLoader();
        }
    };

    const handleDelete = async () => {
        try {
            loaderStore.getState().showLoader("Kitob o'chirilmoqda...");
            await deletePDFFromIndexedDB(book.id);
            setIsDownloaded(false);
        } catch (error) {
            console.error("Kitobni o'chirishda xatolik:", error);
        } finally {
            loaderStore.getState().hideLoader();
        }
    };

    return (
        <div className={css.card}>
            <div className={css.imgWrapper}>
                <div
                    className={css.bookBg}
                    style={{ backgroundImage: 'url(' + (book.img || bookempty) + ')' }}
                />
                <img
                    alt={book.name}
                    className={css.bookCover}
                    src={book.img}
                />
            </div>
            <div className={css.body}>
                <div className={css.badges}>
                    <span className={css.badgeAuthor}>{book.autor}</span>
                    <span className={css.badgeCat}>{book.cat}</span>
                </div>
                <p className={css.title}>{book.name}</p>
                <div className={css.actions}>
                    {isDownloaded ? (
                        <Popconfirm
                            title="Kitobni o'chirish"
                            description="Haqiqatan ham bu kitobni o'chirmoqchimisiz?"
                            onConfirm={handleDelete}
                            okText="Ha"
                            cancelText="Yo'q"
                        >
                            <Button
                                danger
                                type="primary"
                                icon={<DeleteOutlined />}
                                block
                            >
                                O'chirish
                            </Button>
                        </Popconfirm>
                    ) : (
                        <Button
                            type="primary"
                            loading={loadstatus}
                            block
                            icon={<DownloadOutlined />}
                            onClick={handleDownload}
                        >
                            Saqlash
                        </Button>
                    )}
                    <Link to={'/book/' + book.id}>
                        <Button
                            block
                            type="default"
                            icon={<InfoCircleOutlined />}
                        >
                            Batafsil
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default BookCard;